/* ==========================================================================
   SpaceHawk GPS — collection page behaviour

   NOTE: every section renders its own <div class="shc-page"> wrapper, so
   there are many of them on the page. Scope every query to `document`,
   never to a single .shc-page — doing that binds only the first section
   (the hero) and silently leaves the grid, video and sticky bar dead.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.shRoutes || {};
  var money = function (cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.shMoneyFormat || '${{amount}}')
      : '$' + (cents / 100).toFixed(2);
  };

  /* ---------------------------------------------------------------
     1. Quantity steppers + live "Due today"
     --------------------------------------------------------------- */
  function cardTotal(card) {
    var input = card.querySelector('[data-sh-qty]');
    var qty = input ? (parseInt(input.value, 10) || 1) : 1;
    return (parseInt(card.dataset.price, 10) || 0) * qty;
  }

  var cards = document.querySelectorAll('.shc-card');

  cards.forEach(function (card) {
    var input = card.querySelector('[data-sh-qty]');
    if (!input) return;
    var total = card.querySelector('[data-sh-total]');

    function refresh() {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 20;
      var v = Math.min(max, Math.max(min, parseInt(input.value, 10) || min));
      input.value = v;
      if (total) total.textContent = money(cardTotal(card));
      if (current === card) syncSticky(card);
    }

    card.querySelectorAll('[data-sh-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.shStep, 10);
        refresh();
      });
    });

    input.addEventListener('input', refresh);
    input.addEventListener('change', refresh);
  });

  /* ---------------------------------------------------------------
     2. Cart helpers
     --------------------------------------------------------------- */
  var drawer = document.querySelector('cart-drawer');
  var bubble = document.getElementById('cart-icon-bubble');

  function refreshCartUI(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var doc = new DOMParser().parseFromString(sections[key], 'text/html');
      if (key.indexOf('cart-drawer') > -1 && drawer) {
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      }
      if (key.indexOf('cart-icon-bubble') > -1 && bubble) {
        var b = doc.getElementById('cart-icon-bubble');
        if (b) bubble.innerHTML = b.innerHTML;
      }
    });
    if (drawer && typeof drawer.open === 'function') {
      drawer.classList.remove('is-empty');
      drawer.open();
    }
  }

  function toast(msg) {
    var t = document.getElementById('sh-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }

  function addToCart(form, opts) {
    opts = opts || {};
    var btn = opts.button;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = opts.busy || 'Adding…'; }

    var data = new FormData(form);
    data.append('sections', 'cart-drawer,cart-icon-bubble');
    data.append('sections_url', window.location.pathname);

    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Could not add that'); return; }
        refreshCartUI(res.sections);
        toast((form.dataset.shName || 'Item') + ' added to cart');
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }

  /* Add to cart.
     Delegated on document so it covers every form on the page — grid,
     accessory strip, compare table, sticky bar — including any section
     re-rendered by the theme editor after load. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-sh-form]');
    if (!form) return;
    if (!window.fetch || !routes.cartAdd) return;   // let it post normally
    e.preventDefault();
    addToCart(form, { button: form.querySelector('[type="submit"]') });
  });

  /* Buy now.
     Uses Shopify's own return_to parameter rather than fetch: the form
     posts to /cart/add and Shopify redirects to checkout itself. No AJAX,
     no dependency on window.shRoutes, works in every section and still
     works if the script that defines the routes never ran. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sh-buynow]');
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;
    e.preventDefault();

    var rt = form.querySelector('input[name="return_to"]');
    if (!rt) {
      rt = document.createElement('input');
      rt.type = 'hidden';
      rt.name = 'return_to';
      form.appendChild(rt);
    }
    rt.value = '/checkout';

    btn.disabled = true;
    btn.textContent = 'Taking you to checkout…';

    // native submit — deliberately skips the AJAX handler above
    form.submit();
  });

  /* ---------------------------------------------------------------
     3. Chooser
        The tiles are links, so they already work with no JS at all.
        This only intercepts when there's a matching card to highlight —
        otherwise the browser follows the href as normal.
     --------------------------------------------------------------- */
  var answer = document.getElementById('sh-answer');

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-sh-pick]');
    if (!chip) return;

    // an explicit link always wins — let the browser navigate
    if (chip.dataset.shUrl) return;

    var handle = chip.dataset.shPick;
    var target = handle
      ? document.querySelector('.shc-card[data-handle="' + handle + '"]')
      : null;
    if (!target) return;                  // no card here: follow the href

    e.preventDefault();

    var chips = document.querySelectorAll('[data-sh-pick]');
    var wasOn = chip.classList.contains('is-on');
    chips.forEach(function (c) { c.classList.remove('is-on'); });
    cards.forEach(function (c) { c.classList.remove('is-pick'); });
    if (answer) { answer.classList.remove('is-on'); answer.innerHTML = ''; }
    if (wasOn) return;

    chip.classList.add('is-on');
    if (answer && chip.dataset.shAnswer) {
      answer.innerHTML = chip.dataset.shAnswer;
      answer.classList.add('is-on');
    }

    target.classList.add('is-pick');
    syncSticky(target);
    setTimeout(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 120);
  });

  /* ---------------------------------------------------------------
     4. Click-to-play video
     --------------------------------------------------------------- */
  document.querySelectorAll('[data-sh-video]').forEach(function (vid) {
    var play = function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + vid.dataset.shVideo + '?autoplay=1&rel=0';
      f.title = vid.dataset.shTitle || 'Video';
      f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      vid.innerHTML = '';
      vid.appendChild(f);
      vid.style.cursor = 'default';
    };
    vid.addEventListener('click', play);
    vid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); }
    });
  });

  /* ---------------------------------------------------------------
     5. Sticky buy bar
     --------------------------------------------------------------- */
  var sticky  = document.getElementById('sh-sticky');
  var sImg    = document.getElementById('sh-sticky-img');
  var sTxt    = document.getElementById('sh-sticky-txt');
  var sPrice  = document.getElementById('sh-sticky-price');
  var sForm   = document.getElementById('sh-sticky-form');
  var sId     = document.getElementById('sh-sticky-id');
  var sQty    = document.getElementById('sh-sticky-qty');
  var current = cards[0];

  function syncSticky(card) {
    if (!card || !sticky) return;
    current = card;
    var qtyInput = card.querySelector('[data-sh-qty]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    if (sImg && card.dataset.img) sImg.src = card.dataset.img;
    if (sTxt) sTxt.innerHTML = card.dataset.name +
      (card.dataset.sub ? '<small>' + card.dataset.sub + '</small>' : '');
    if (sPrice) sPrice.textContent = money(cardTotal(card));
    if (sId) sId.value = card.dataset.variant;
    if (sQty) sQty.value = qty;
    if (sForm) sForm.dataset.shName = card.dataset.name;
  }
  if (current) syncSticky(current);

  var onScroll = function () {
    if (sticky) sticky.classList.toggle('is-on', window.scrollY > 760);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if ('IntersectionObserver' in window && cards.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio > 0.55) syncSticky(e.target);
      });
    }, { threshold: [0.55] });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* ---------------------------------------------------------------
     6. Reveal on scroll
        Unobserves after firing — these animate once, not every pass.
     --------------------------------------------------------------- */
  var reveals = document.querySelectorAll('[data-sh-reveal]');
  if (reveals.length) {
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var ro = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
      reveals.forEach(function (el) { ro.observe(el); });
    }
  }
})();